import React, { useEffect, useState } from "react";
import { Slice } from "gatsby";
import OldFooter from "../../common/OldFooter/Footer";
import "react-dates/initialize";
import { Location, useLocation } from "@reach/router";
import { container } from "./Layout.module.scss";
import { LayoutWrapper, isPathExcluded } from "./LayoutHelpers";
import { ILayout } from "./LayoutProps";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  brandSelector,
  brandsSelector,
} from "../../../redux/slices/Brand/brand";
import IBrand from "../../../@types/IBrand";
import { selectBrand } from "../../../redux/slices/Brand/brand";
import SearchBreadCrumb from "../../common/SearchBreadCrumb/SearchBreadCrumb";
import SocialMedia from "../../common/SocialMedia/SocialMedia";
import HotelSummary from "../../common/HotelSummary/HotelSummary";
import { FooterSliceProvider } from "../../../context/SliceContexts/FooterContext";
import { HeaderSliceProvider } from "../../../context/SliceContexts/HeaderContext";
import { SearchSliceProvider } from "../../../context/SliceContexts/SearchContext";
import { GlobalAlertSliceProvider } from "../../../context/SliceContexts/GlobalAlertContext";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendar,
  faHandshake,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import {
  faAngleDown,
  faAngleUp,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faHome,
  faCalendarWeek,
  faTrophy,
  faTimes,
  faDrum,
  faArrowLeft,
  faInfoCircle,
  faList,
  faMapMarkerAlt,
  faShoppingCart,
  faLongArrowAltRight,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faPhoneAlt,
  faImage,
  faUserFriends,
  faBed,
  faTag,
  faCheck,
  faExpand,
  faCreditCard,
  faPlusCircle,
  faMinusCircle,
  faCheckCircle,
  faDollarSign,
  faConciergeBell,
  faDharmachakra,
  faCopy,
  faExclamationCircle,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";

import "@fortawesome/fontawesome-svg-core/styles.css";
import { saveRatePlanFilter } from "../../../redux/slices/Rate/rate";
import { navigate } from "gatsby";
import {
  setSearch,
  setSearchDiscountTime,
} from "../../../redux/slices/Search/search";
import { useWebFramed } from "../../../hooks/useWebFramed";
import Ribbon from "../../common/Ribbon/Ribbon";
import GoNativeSunsetBanner from "../../common/GoNativeSunsetBanner/GoNativeSunsetBanner";
import {
  FRAMED_WEB_EXCLUDEED_PATHS,
  RATEPLAN_FILTER_CODE,
  META_RATEPLAN_FILTER_CODE,
} from "../../../@types/Constants";
import { ScrollVisibilityProvider } from "../../../context/scrollVisibilityContext";
import { MobileDetectProvider } from "../../../context/MobileDetectContext";
import { useMediaQuery } from "../../../hooks/useMediaQuery";

library.add(
  faAngleDown,
  faAngleUp,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faUser,
  faHome,
  faCalendarWeek,
  faTrophy,
  faTimes,
  faHandshake,
  faDrum,
  faDharmachakra,
  faArrowLeft,
  faInfoCircle,
  faList,
  faMapMarkerAlt,
  faShoppingCart,
  faLongArrowAltRight,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faPhoneAlt,
  faImage,
  faUserFriends,
  faBed,
  faCalendar,
  faTag,
  faCheck,
  faExpand,
  faCreditCard,
  faPlusCircle,
  faMinusCircle,
  faCheckCircle,
  faDollarSign,
  faConciergeBell,
  faCopy,
  faExclamationCircle,
  faDownload
);

const MainLayout: React.FC<ILayout> = (props) => {
  //Hooks
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isWebFramed = useWebFramed();

  //state selectors
  const brands = useAppSelector(brandsSelector);
  const selectedBrand = useAppSelector(brandSelector);
  const ratePlanFilter = useAppSelector((state) => state.ratePlanFilter);
  const search = useAppSelector((state) => state.search);
  const dicountSetTime = useAppSelector((state) => state.searchDiscountSetTime);

  //state
  const [showEditSearch, setShowEditSearch] = useState(false);
  const [showMetaHotelSummary, setShowMetaHotelSummary] = useState(false);

  const isHotelPage = props.isHotelPage || false;
  const isBrandPage = props.isBrandPage || false;
  const isEditReservationPage = props.isEditReservationPage || false;
  const params = new URLSearchParams(location.search);
  const isMobile = useMediaQuery("(max-width: 480px)");
  const isFeatureEnabled =
    process.env.GATSBY_DISPLAY_META_HOTEL_SUMMARY_MOBILE === "true";
  useEffect(() => {
    if (location.pathname == "/americas-best-value-inn") {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    }
  }, [location.pathname]);

  const redlionLinksRegex = [
    "/americas-best-value-inn",
    "/red-lion-hotels",
    "/canadas-best-value-inn",
    "/signature-inn",
    "/red-lion-hotels-suites",
  ];
  const url =
    typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
  const isRLFirstSessionPage =
    isHotelPage || isBrandPage
      ? redlionLinksRegex.some((regex) => url.includes(regex.toLowerCase()))
      : false;

  let showRibbonUrlVal: string | null = null;
  let isMetaRateplanFilterCode = false;
  params.forEach((value, key) => {
    if (key.toLowerCase() === "showbanner") {
      showRibbonUrlVal = value;
    } else if (
      key.toLowerCase() === RATEPLAN_FILTER_CODE &&
      value.toLowerCase() === META_RATEPLAN_FILTER_CODE
    ) {
      isMetaRateplanFilterCode = true;
    }
  });

  useEffect(() => {
    if (
      isMetaRateplanFilterCode &&
      process.env.GATSBY_DISPLAY_META_HOTEL_SUMMARY === "true"
    ) {
      setShowMetaHotelSummary(true);
      sessionStorage.setItem("metaUser", "true");
    }
  }, [isMetaRateplanFilterCode]);

  useEffect(() => {
    const COOKIE_NAME = "web_analytics_consent";

    function setConsentCookie(value: "true" | "false") {
      const existing = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${COOKIE_NAME}=`))
        ?.split("=")[1];

      if (existing === value) {
        return;
      }

      document.cookie = `${COOKIE_NAME}=${value}; path=/; SameSite=Lax`;
    }

    function updateConsentBasedOnOsano() {
      const consent = window.Osano?.cm?.analytics;
      if (typeof consent === "undefined") {
        return;
      }

      setConsentCookie(consent === true ? "true" : "false");
    }

    // Run once if Osano is already ready
    if (
      typeof window !== "undefined" &&
      window.Osano &&
      window.Osano.cm &&
      typeof window.Osano.cm.analytics !== "undefined"
    ) {
      updateConsentBasedOnOsano();
    } else {
      // Retry after short delay if not available yet
      const interval = setInterval(() => {
        if (
          window.Osano &&
          window.Osano.cm &&
          typeof window.Osano.cm.analytics !== "undefined"
        ) {
          updateConsentBasedOnOsano();
          clearInterval(interval);
        }
      }, 300);

      // Stop trying after 10 seconds
      setTimeout(() => clearInterval(interval), 10000);
    }

    function updateFromCurrentConsent() {
      const consent = window.Osano?.cm?.analytics;
      const value = consent === true ? "true" : "false";
      setConsentCookie(value);
    }

    window.Osano?.cm?.addEventListener("osano-cm-consent-saved", () => {
      updateFromCurrentConsent();
    });
  }, []);

  // const GATSBY_MOBILE_APP = process.env.GATSBY_MOBILE_APP === "true" ? true : false;
  if (location && location.pathname.indexOf("/travel-pass/tpguest") != -1) {
    const path = location.pathname.split("/");
    const searchParams = new URLSearchParams(location.search);
    const hId = path ? path.pop() : 0;

    !isNaN(hId) && hId && searchParams.set("hid", hId);

    const redirectToUrl = new URL(
      "https://ww3.sonesta.com/property-enrollment/"
    );
    redirectToUrl.search = searchParams.toString();
    const newPath = redirectToUrl && redirectToUrl.toString();
    if (newPath) {
      navigate(newPath, { replace: true });
      return null;
    }
  }

  if (location && location.pathname.indexOf("/travel-pass/sign-up") != -1) {
    const searchParams = location.search;
    const redirectToUrl = `/join-travel-pass${searchParams}`;
    navigate(redirectToUrl, { replace: true });
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    dispatch(setSearchDiscountTime(Date.now()));
  }, [search.groupCode, search.promotionCode]);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    let didCancel = false;
    const brand = determineBrand(location, brands);
    const rateFilterFromCore = "Retail"; // TODO: fetch this value from core backend
    if (!didCancel) {
      let updatedSelectBrand = null;
      if (brand.length && brand[0]) {
        updatedSelectBrand = brand[0];
      } else if (props.showLogo) {
        updatedSelectBrand = selectedBrand;
      }
      dispatch(selectBrand(updatedSelectBrand));
    }
    // !didCancel && dispatch(selectBrand(brand.length ? brand[0] : null));
    !didCancel &&
      !ratePlanFilter &&
      dispatch(saveRatePlanFilter(rateFilterFromCore));

    // check discount code set time and clear if older than 24 hrs
    if (dicountSetTime && (search.groupCode || search.promotionCode)) {
      const nowTime = Date.now();
      const discuntValidForMinutes =
        process.env.GATSBY_DISCOUNT_VALID_MINUTES || "1440"; //24 hours
      const discuntValidForMilliSeconds =
        parseInt(discuntValidForMinutes) * 60 * 1000;
      const discountValidTime = nowTime - discuntValidForMilliSeconds;
      if (parseInt(dicountSetTime) < discountValidTime) {
        dispatch(
          setSearch({ ...search, ...{ groupCode: null, promotionCode: null } })
        );
      }
    }

    return () => {
      didCancel = true;
    };
  }, []);
  // Check for "gonative" in user agent and render GoNativeSunsetBanner component if true
  const isGoNative =
    typeof navigator !== "undefined" &&
    navigator.userAgent.indexOf("gonative") > -1;

  // Check if the code is running in a browser environment and if the current path is in the excluded paths list
  const isCurrentPathExcluded =
    typeof window !== "undefined" &&
    isPathExcluded(window.location.pathname, FRAMED_WEB_EXCLUDEED_PATHS);

  // Determine if the SearchBar should be displayed
  const shouldShowSearchBar =
    (isWebFramed && !isCurrentPathExcluded) || // Show SearchBar if the app is web-framed and the current path is not excluded
    (!isWebFramed && // OR if the app is not web-framed
      !props.reservation && // and there is no ongoing reservation
      !isEditReservationPage && // and the current page is not an edit reservation page
      !props.hideSearchBar); // and the SearchBar is not explicitly hidden via props

  return (
    <Location>
      {({ location }) => {
        // determineBrand(location, brands);
        return (
          <MobileDetectProvider>
            <ScrollVisibilityProvider>
              <LayoutWrapper>
                {isGoNative ? (
                  <GoNativeSunsetBanner />
                ) : (
                  <>
                    <div id="speed-rfp-container-wrapper"></div>
                    {!isWebFramed && (
                      <HeaderSliceProvider value={{ location: location }}>
                        <Slice alias="header" />
                      </HeaderSliceProvider>
                    )}
                    {(isFeatureEnabled || !isMobile) && (
                      <div id="meta-hotel-summary" className="metaHotelSummary">
                        {!isWebFramed &&
                          props.hotel &&
                          showMetaHotelSummary &&
                          props.searchBreadCrumbStep === 2 && (
                            <HotelSummary hotel={props.hotel} />
                          )}
                      </div>
                    )}
                    {shouldShowSearchBar ? (
                      <SearchSliceProvider
                        value={{
                          location: location,
                          isHotelPage: isHotelPage,
                          showEditSearch: showEditSearch,
                          onShowEditSearch: setShowEditSearch,
                        }}
                      >
                        <Slice alias="search-bar" />
                      </SearchSliceProvider>
                    ) : null}
                    {!isWebFramed && (
                      <SearchBreadCrumb
                        location={location}
                        step={props.searchBreadCrumbStep}
                        hotel={props.hotel}
                        handleGoToGuestDetailsStep={
                          props.handleGoToGuestDetailsStep
                        }
                      />
                    )}
                    <GlobalAlertSliceProvider value={{ brand: props.brand }}>
                      <Slice alias="global-alert" />
                    </GlobalAlertSliceProvider>
                    <main
                      id="main-content"
                      className={`${container} layoutContainer`}
                      role="main"
                    >
                      {props.children}
                    </main>
                    {!isWebFramed && !props.hideSocialBar && <SocialMedia />}

                    {!isWebFramed &&
                      (process.env.GATSBY_DISPLAY_NEW_FOOTER === "true" ? (
                        <FooterSliceProvider
                          value={{
                            location,
                            showMerchandisingBlock:
                              props.showMerchandisingBlock || false,
                          }}
                        >
                          <Slice alias="footer" />
                        </FooterSliceProvider>
                      ) : (
                        <OldFooter
                          location={location}
                          showMerchandisingBlock={props.showMerchandisingBlock}
                        />
                      ))}
                  </>
                )}
              </LayoutWrapper>
            </ScrollVisibilityProvider>
          </MobileDetectProvider>
        );
      }}
    </Location>
  );
};
const determineBrand = (location: any, brands: Array<IBrand> | undefined) => {
  // const dispatch = store.dispatch;
  const _brands = brands ? brands : [];

  type SearchParamsObject = { [key: string]: any };
  const searchParams: SearchParamsObject = new URLSearchParams(location.search);
  const queryParams = Object.fromEntries(searchParams);
  const queryParamsLowercase = Object.keys(queryParams).reduce((qp, key) => {
    qp[key.toLowerCase()] = queryParams[key];
    return qp;
  }, {} as SearchParamsObject);
  const brandCodes: Array<string> = queryParamsLowercase.brandcodes
    ? queryParamsLowercase.brandcodes.split(",")
    : [];
  const defaultBrandCode =
    brandCodes.length <= 1
      ? brandCodes[0]
      : queryParamsLowercase.defaultbrand || brandCodes[0];

  const brand: Array<IBrand> = _brands?.filter((b: IBrand) => {
    return location.pathname.indexOf(b.path.alias) > -1;
  });

  if (brand.length) {
    // if it's brand page then it'll take precedence over brand passed in querystring
    return brand;
  }

  const deepLinkBrand: Array<IBrand> = _brands?.filter(
    (b: IBrand) => b.brand_code != null && defaultBrandCode == b.brand_code
  );

  return deepLinkBrand;
};
export default MainLayout;
